import React, { MouseEventHandler, useEffect, useState } from "react";
import cn from "classnames";
import styled from "styled-components";
import { useSelectCompanyQuery } from "src/api/userAPI";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

interface IBottomProps {
  multiSelect?: boolean;
  selectedCom?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  selectCompanyItemToFunc?: any;
  isCancelClick?: boolean;
}

const SelectCompanyItem = (props: IBottomProps) => {
  const [selectedCompanyId, setSelectedCompanyId]: any = useState([]);
  const [selectedCompanyName, setSelectedCompanyName]: any = useState([]);
  const companyList = useSelectCompanyQuery("");

  useEffect(() => {
    props.selectCompanyItemToFunc(selectedCompanyId, selectedCompanyName);
  }, [selectedCompanyId, selectedCompanyName]);

  useEffect(() => {
    if (props.isCancelClick) {
      setSelectedCompanyId(props.selectedCom);
    }
  }, [props]);

  useEffect(() => {
    if (!isEmpty(props.selectedCom)) {
      if (props.multiSelect) {
        setSelectedCompanyId([props.selectedCom]);
      } else {
        setSelectedCompanyId(props.selectedCom);
      }
    }
  }, [props.selectedCom]);

  useEffect(() => {
    if (companyList.isSuccess) {
      if (companyList.data.data) {
        // if (isEmpty(props.selectedCom)) {
        //   const user_id: string = companyList.data.data[0].user_id;
        //   dispatch(selectCompany(user_id));
        // }
        // setActiveSort(companyList.data.data.findIndex((i: any) => i.name == props.selectedCom));
        // if (activeSort === -1) {
        //   setActiveSort(0);
        // }
      }
    }
  }, [companyList]);

  const handleClick = (e: React.MouseEvent, i: number, name: string) => {
    const buttonElement: any = e.currentTarget.children[0];
    const companyId = buttonElement.defaultValue;
    if (props.multiSelect) {
      if (selectedCompanyId.includes(companyId)) {
        // 이미 선택되 있는 요소면 빼기
        const filteredComId = selectedCompanyId.filter((v: any) => v !== companyId);
        setSelectedCompanyId(filteredComId);
      } else {
        // 선택되 있는 요소랑 다른거면 기존꺼 + 새로 선택된거 추가
        setSelectedCompanyId([...selectedCompanyId, companyId]);
      }
    } else {
      setSelectedCompanyId(companyId);
      setSelectedCompanyName(name);
    }
  };

  return (
    <>
      {companyList.isSuccess && companyList.data.data && (
        <SelectItemSet>
          {companyList.data.data.map((v: any, i: number) => {
            return (
              <li key={i}>
                <button className={cn({ selected: selectedCompanyId.includes(v.user_id) })} onClick={(e) => handleClick(e, i, v.name)}>
                  {v.name}
                  <input type="hidden" value={v.user_id} />
                </button>
              </li>
            );
          })}
        </SelectItemSet>
      )}
    </>
  );
};

const SelectItemSet = styled.ul`
  position: relative;
  padding: 0 15px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "stretch", "wrap")}
  &::after {
    position: absolute;
    left: 0;
    bottom: 0;
    content: "";
    display: block;
    width: 100%;
    height: 2px;
    background: #fff;
  }
  > li {
    display: inline-block;
    padding: 0 10px;
    flex-basis: 50%;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    &:nth-child(odd) {
      border-right: 1px solid ${({ theme }) => theme.color.linePrimary};
    }
    > button {
      width: 100%;
      height: 100%;
      padding: 25px 0;
      border: none;
      background: none;
      color: #7f7f7f;
      font-size: 20px;
      font-family: "Roboto";
      font-weight: 500;
      &.selected {
        color: ${({ theme }) => theme.color.main};
      }
    }
  }
`;

export default SelectCompanyItem;
